/**
 * Cliente HTTP de Cupones: wrappers tipados sobre `req()` de campana-nueva. Nunca se manda el comercio (sale del
 * token). Es del equipo: con el token de una persona de un cliente, el backend dice 403.
 */

import { req } from "../campana-nueva/api";
import type { Resp } from "../wa-oficial/api";
import type * as T from "./types";

const B = "/activa/cupones";

export const cuponesApi = {
  listar: (): Promise<Resp<T.ListaCupones>> => req("GET", B),
  crear: (c: T.CuponParaGuardar): Promise<Resp<T.Cupon>> => req("POST", B, c),
  /** propone un código libre (la palabra, o VOLVE, más 4 caracteres al azar); no guarda nada */
  generar: (palabra: string): Promise<Resp<{ codigo: string }>> => req("POST", `${B}/generar`, { palabra }),
  editar: (id: string, c: T.CuponParaGuardar): Promise<Resp<T.Cupon>> => req("PATCH", `${B}/${encodeURIComponent(id)}`, c),
  archivar: (id: string): Promise<Resp<T.Cupon>> => req("POST", `${B}/${encodeURIComponent(id)}/archivar`),
  reactivar: (id: string): Promise<Resp<T.Cupon>> => req("POST", `${B}/${encodeURIComponent(id)}/reactivar`),
};
